import { ENV_PROD } from 'constants/environment';

/** Hors prod, l'API tourne sur les clés de test : ses clients n'existent que dans le mode test du dashboard. */
export const getStripeDashboardUrl = (): string =>
    window.__TOTENV__.ENV === ENV_PROD ? 'https://dashboard.stripe.com' : 'https://dashboard.stripe.com/test';

/** Sans identifiant, ouvre la liste des clients. */
export const getStripeCustomerUrl = (stripeCustomerId?: string | null): string =>
    `${getStripeDashboardUrl()}/customers${stripeCustomerId ? `/${stripeCustomerId}` : ''}`;
